module.exports = __webpack_public_path__ + "img/OctopharmaLogo.c7613a94.png";